
import React from 'react';
import { User } from '@/types';
import { Badge } from '@/components/ui/badge';
import { useFriendships } from '@/hooks/useFriendships';
import { UserPlus } from 'lucide-react';
import GolferSelector from '@/components/GolferSelector';

interface PlayerSelectorProps {
  selectedPlayers: User[];
  onPlayerSelect: (golfer: User) => void;
  onPlayerRemove: (golferId: string) => void;
}

const PlayerSelector: React.FC<PlayerSelectorProps> = ({
  selectedPlayers,
  onPlayerSelect,
  onPlayerRemove
}) => {
  const {
    friends,
    sentRequests,
    createManualFriend,
    isLoading: isLoadingFriends
  } = useFriendships();

  return (
    <div className="my-6">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-base font-medium">Select Players</h3>
        <Badge variant="outline" className="bg-forest text-white">
          {selectedPlayers.length} player{selectedPlayers.length !== 1 ? 's' : ''}
        </Badge>
      </div>

      {isLoadingFriends ? (
        <div className="text-center py-4">
          <p className="text-muted-foreground">Loading friends...</p>
        </div>
      ) : (friends.length === 0 && sentRequests.length === 0) ? (
        <div className="text-center py-6 border border-dashed rounded-md border-border">
          <UserPlus className="h-8 w-8 mx-auto text-muted-foreground mb-2" />
          <p className="text-muted-foreground">No friends yet</p>
          <p className="text-sm text-muted-foreground mt-1">Add friends on the Friends page</p>
        </div>
      ) : (
        <GolferSelector
          selectedGolfers={selectedPlayers}
          onGolferSelect={onPlayerSelect}
          onGolferRemove={onPlayerRemove}
          allGolfers={[]}
          confirmedFriends={friends}
          pendingFriends={sentRequests}
          showFriendStatus={true}
          onCreateManualPlayer={createManualFriend}
        />
      )}
    </div>
  );
};

export default PlayerSelector;
